<template>
  <div class="col-sm-12">
    <div class="card">
      <div class="action-bar">
        <input 
          type="text" 
          class="form-control search-input" 
          placeholder="Search by Account No or Name..." 
          v-model="searchQuery" 
        />
        <button type="button" class="btn button-default new-item-btn" @click="newBanks">
          Create Bank Account
        </button>
      </div>

      <!-- added by isindu | 2025/ 12/ 02 -->
      <div v-if="loading" class="loading-spinner">
        <i class="fa fa-spinner fa-spin"></i> Loading...
      </div>

      <!-- added v-else by isindu | 2025/ 12/ 02 -->
      <table v-else class="table">
        <thead>
        <tr class="border-bottom-primary">
          <th scope="col">Bank</th>
          <th scope="col">Branch</th>
          <th scope="col">Account Name</th>
          <th scope="col">Account No</th>
          <th scope="col">Status</th>
          <th scope="col">Action</th>
        </tr>
        </thead>
        <tbody>

        <tr v-for="bank in filteredBanks" :key="bank.id">
          <td>{{ bank.bank_name }}</td>
          <td>{{ bank.branch_name }}</td>
          <td>{{ bank.account_name }}</td>
          <td>{{ bank.account_no }}</td>
          <td>
            <span :class="bank.is_active === '1' ? 'badge badge-active' : 'badge badge-cancel'">
              {{ bank.is_active === '1' ? 'ACTIVE' : 'INACTIVE' }}
            </span>
          </td>
          <td>
            <i class="fa fa-edit" @click="editBank(bank.id)"></i>
          </td>
        </tr>

        <tr v-if="!filteredBanks.length">
          <td colspan="6" class="text-center no-data">No banks found.</td>
        </tr>
        </tbody>
      </table>


    </div>
  </div>
</template>

<script>
import { useRouter } from "vue-router";
import {fetchAllBanksList} from "@/services/dataService";


export default {
  data() {
    return {
      //Get the API access token from the local storage
      token: localStorage.getItem('token_set'),

      //Get the company id from the local storage
      companyId: localStorage.getItem('company_id'),

      profileId: localStorage.getItem('profile_id'),
      reportingProfileId: localStorage.getItem('reportingL1ProfileId'),
      userCategory: localStorage.getItem('user_label'),

      router: useRouter(),
      loading: false,
      banksList: [],
      banksDetails: {},
      searchQuery: "",
    }
  },

  computed: {
    filteredBanks() {
      if (!this.searchQuery) {
        return this.banksList;
      }
      const query = this.searchQuery.toLowerCase();
      return this.banksList.filter(bank => 
        (bank.account_no || "").toLowerCase().includes(query) ||
        (bank.account_name || "").toLowerCase().includes(query)
      );
    }
  },

  created() {
    this.fetchBanks();
  },

  methods: {
    //Call bank list fetch API
    async fetchBanks() {
      this.loading = true;
      try {
        let idToUse = this.profileId;
        if (this.userCategory === 'DISTRIBUTOR BACK OFFICE') {
          idToUse = this.reportingProfileId;
        }
        const response = await fetchAllBanksList(idToUse, this.token);
        this.banksList = response.data.data || [];
      } catch (error) {
        console.error("Error fetching bank list:", error);
        this.banksList = [];
      } finally {
        this.loading = false;
      }
    },

    newBanks() {
      this.$router.push({path: "/new-banks"});
    },

    editBank(id) {
      this.router.push({path: `/edit-banks/${id}` });
    },

  }
}
</script>

<style scoped lang="scss">
.card {
  padding: 10px;
}

.action-bar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
  gap: 15px;
}

.search-input {
  max-width: 300px;
  padding: 10px;
  border-radius: 5px;
  border: 1px solid #ccc;
  width: 100%;
}

.search-input:focus {
  border-color: #007bff;
  box-shadow: 0 0 5px rgba(38, 143, 255, 0.5);
  outline: none;
}

.new-item-btn {
  margin: 0;
  padding: 10px 20px;
}

.fa-eye {
  cursor: pointer;
  transition: color 0.3s, transform 0.3s;
  margin-left: 5px;
}

.fa-eye:hover {
  color: #0056b3;
  transform: scale(1.2);
}

.fa-eye:active {
  transform: scale(1.1);
}

.fa-edit {
  cursor: pointer;
  transition: color 0.3s, transform 0.3s;
}

.fa-edit:hover {
  color: #0056b3;
  transform: scale(1.2);
}

.fa-edit:active {
  transform: scale(1.1);
}

.badge {
  display: inline-block;
  padding: 4px 12px;
  border-radius: 5px;
  font-size: 0.75rem;
  text-transform: uppercase;
  letter-spacing: 0.5px;
  min-width: 80px;
  max-width: 80px;
}

.badge-active {
  background-color: #28a745; /* green */
}

.badge-cancel {
  background-color: #dc3545; /* red */
}


// added by isindu | 2025/ 12/ 02
.loading-spinner {
  font-size: 18px;
  text-align: center;
  margin: 20px 0;
  color: #007bff;
}

.no-data {
  color: #888;
  padding: 20px 0;
}
</style>